import React from 'react';
import { Field } from 'redux-form/immutable';
import { CheckboxToggle } from 'cstar-react-primitives/lib/redux-form/microFields/CheckboxToggle';
import { FieldDivWrapper } from 'cstar-react-primitives/lib/redux-form/layout/FieldLayout';
import { intlShape, injectIntl } from 'react-intl';

import { ACCEPTED_GDPR_TERMS_AGREEMENT } from './consentModule';
import consentMessages from './consentMessages';


export const GDPRTermsAcknowledgementField = ({
    intl
}) => {
    const checkboxProps = {
        name: ACCEPTED_GDPR_TERMS_AGREEMENT,
        label: intl.formatMessage(consentMessages.termsAcknowledgementMessage,
            {
                policyUrl: '/store/self_service/v2/about/privacy_policy',
                termsUrl: '/store/self_service/v2/about/terms_and_conditions'
            }),
        component: CheckboxToggle,
        openLinksInNewTab: true,
        styleType: 'checkbox',
        cashbotName: 'gdpr-terms-agreement',
        isRequiredField: true
    };

    return (
        <div className="payment-gdpr-terms-agreement">
            <FieldDivWrapper>
                <Field {...checkboxProps} />
            </FieldDivWrapper>
        </div>
    );
};

GDPRTermsAcknowledgementField.propTypes = {
    intl: intlShape.isRequired
};

export default injectIntl(GDPRTermsAcknowledgementField);
